module.exports = __webpack_public_path__ + "static/media/cloudy_moon.961673a4.svg";